import { FireBaseService, MainMenuService, DiscountPopupService } from "shared/services";
import { EventBus } from "shared/emmiter";
import { PreloaderHelper } from "shared/helpers";
import config from "config";

export class LeaderboardService {
    public async show(): Promise<void> {
        await this.createUsers();
        const leaderboard = document.getElementById('leaderboard');
        leaderboard.style.display = 'block';

        EventBus.emit('hide_main');
        PreloaderHelper.togglePreloader(false);
    }

    public hide(): void {
        const leaderboard = document.getElementById('leaderboard');
        leaderboard.style.display = 'none';

        const main = document.getElementById('main_page');
        main.style.display = 'flex';

        const list = document.getElementById('leaderboard_list');
        list.innerHTML = '';
    }

    private async createUsers(): Promise<void> {
        const users = [];
        const list = document.getElementById('leaderboard_list');
        const currentUser = JSON.parse(localStorage.getItem('mbny_game_user'));
        // await FireBaseService.getUserLeaderbord().then((querySnapshot) => {
        //     querySnapshot.forEach((doc) => {
        //         const user = {
        //             id: doc.id,
        //             name: doc.data().userName,
        //             score: doc.data().score
        //         }
        //         users.unshift(user)
        //     });
        // });

        // const myHeaders = new Headers();
        // myHeaders.append("Authorization", `Bearer ${config.token}`);
        // myHeaders.append("Cookie", "ASP.NET_SessionId=dg1xim41v5whmzv3abdqy1qo; SC_ANALYTICS_GLOBAL_COOKIE=0d61d83a0a89495f8fdb9e2cc43b4df0|False; cookiesession1=678A3E0D898901234BCDEFGHIJKL234F; sc_expview=0");
        
        if(config.guest) {
            if(config.debugMode) {
                const testData = {
                    status: "200",
                    message: "Success",
                    leaders: [
                        {
                            id: "25eca36c-4c35-4095-8d8c-ce17b4550dfe",
                            nickname: "anacb",
                            score: 250,
                            level: 0,
                            levels: null,
                            tutorials: null
                        },
                        {
                            id: "0855228d-4145-4cef-9aac-7aba2e60c629",
                            nickname: "anacaroline",
                            score: 80,
                            level: 0,
                            levels: null,
                            tutorials: null
                        }
                    ],
                    myUser: {
                        id: "00000000-0000-0000-0000-000000000000",
                        nickname: null,
                        score: 0,
                        level: 0,
                        levels: null,
                        tutorials: null
                    }
                }

                testData.leaders.forEach((doc) => {
                    const user = {
                        id: doc.id,
                        name: doc.nickname,
                        score: doc.score
                    }
                    users.push(user)
                });
            } else {
                if(config.debugMode) {
                    const testData = {
                        status: "200",
                        message: "Success",
                        leaders: [
                            {
                                id: "25eca36c-4c35-4095-8d8c-ce17b4550dfe",
                                nickname: "anacb",
                                score: 250,
                                level: 0,
                                levels: null,
                                tutorials: null
                            },
                            {
                                id: "0855228d-4145-4cef-9aac-7aba2e60c629",
                                nickname: "anacaroline",
                                score: 80,
                                level: 0,
                                levels: null,
                                tutorials: null
                            }
                        ],
                        myUser: {
                            id: "00000000-0000-0000-0000-000000000000",
                            nickname: null,
                            score: 0,
                            level: 0,
                            levels: null,
                            tutorials: null
                        }
                    }

                    testData.leaders.forEach((doc) => {
                        const user = {
                            id: doc.id,
                            name: doc.nickname,
                            score: doc.score
                        }
                        users.push(user)
                    });
                } else {
                    const requestOptions = {
                        method: 'GET',
                        headers: {
                            ContentType: 'application/json;charset=utf-8',
                        },
                        credentials: 'include',
                    };
                    //@ts-ignore
                    await fetch(`${config.path}/match-game/leaderboard-guest?gameId=1234qwer`, requestOptions)
                        .then(response => response.json())
                        .then((result: any) => {
                            console.log(result);
        
                            result.leaders.forEach((doc) => {
                                const user = {
                                    id: doc.id,
                                    name: doc.nickname,
                                    score: doc.score
                                }
                                users.push(user)
                            });
                        })
                        .catch(error => {
                            console.log('error', error);
                        });
                }
                
            }            
        } else {
            if (config.debugMode) {
                const testData = {
                    status: "200",
                    message: "Success",
                    leaders: [
                        {
                            id: "25eca36c-4c35-4095-8d8c-ce17b4550dfe",
                            nickname: "anacb",
                            score: 250,
                            level: 0,
                            levels: null,
                            tutorials: null
                        },
                        {
                            id: "0855228d-4145-4cef-9aac-7aba2e60c629",
                            nickname: "anacaroline",
                            score: 80,
                            level: 0,
                            levels: null,
                            tutorials: null
                        }
                    ],
                    myUser: {
                        id: "00000000-0000-0000-0000-000000000000",
                        nickname: null,
                        score: 0,
                        level: 0,
                        levels: null,
                        tutorials: null
                    }
                }

                testData.leaders.forEach((doc) => {
                    const user = {
                        id: doc.id,
                        name: doc.nickname,
                        score: doc.score
                    }
                    users.push(user)
                });
            } else {
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        ContentType: 'application/json;charset=utf-8',
                        // Authorization: `Bearer ${config.token}`,                    
                    },
                    credentials: 'include',
                };
                //@ts-ignore
                await fetch(`${config.path}/match-game/leaderboard?userId=${config.playerId}`, requestOptions)
                    .then(response => response.json())
                    .then((result: any) => {
                        console.log(result);
        
                        result.leaders.forEach((doc) => {
                            const user = {
                                id: doc.id,
                                name: doc.nickname,
                                score: doc.score
                            }
                            users.push(user)
                        });
                    })
                    .catch(error => {
                        console.log('error', error);                    
                    });
            }
            
        }
       


        const listChild = list.childNodes;
        if (listChild.length > 1) {
            return;
        }

        for (let i = 0; i < users.length; i++) {

            const li = document.createElement('li');
            const div = document.createElement('div');
            const span = document.createElement('span');
            const h4 = document.createElement('h4');
            const h5 = document.createElement('h5');

            if (i === 0) {
                div.classList.add('user_num', 'top', 'top1');
            } else if (i === 1) {
                div.classList.add('user_num', 'top', 'top2');
            } else if (i === 2) {
                div.classList.add('user_num', 'top', 'top3');
            } else {
                div.classList.add('user_num');
            }
            console.log(users[i].name);

            if (users[i].name.length > 11) {
                users[i].name = users[i].name.slice(0, 11);
                users[i].name = `${users[i].name}...`
            }

            span.innerHTML = i + 1 + '';
            div.appendChild(span);
            h4.innerHTML = users[i].name;
            h4.classList.add('user_name');
            h5.innerHTML = Math.floor(users[i].score) + '';
            h5.classList.add('user_score');

            if (users[i].id === currentUser.id) {
                const LD_user = document.getElementById('LD_user');
                LD_user.style.display = 'none';
                list.classList.add('withUser');

                if (i <= 2) {
                    li.classList.add('userInTop')
                } else {
                    li.classList.add('userInList')
                }
            } else {
                list.classList.add('withoutUser');
            }

            li.appendChild(div);
            li.appendChild(h4);
            li.appendChild(h5);

            list.appendChild(li)
        }

        const LD_username = document.getElementById('LD_username');
        LD_username.innerHTML = currentUser.userName;
        const LD_user_score = document.getElementById('LD_user_score');
        LD_user_score.innerHTML = currentUser.score;
    }
}